const nameFields = ["lastKnownName", "queuedName", "nameSyncStatus"];

export const namePatch = (resource, data) => {
  const field = resource === "devices" ? "deviceName" : "outletName";
  if (!data || !Object.prototype.hasOwnProperty.call(data, "nameSyncStatus")) return null;
  return [field, ...nameFields].reduce((patch, key) => {
    if (Object.prototype.hasOwnProperty.call(data, key)) patch[key] = data[key];
    return patch;
  }, {});
};

// A read started before a successful rename must not restore its previous name.
// Later reads remain authoritative, including queuedName:null after replay.
export class NameSyncTracker {
  revision = 0;
  entries = new Map();

  remember(resource, id, data) {
    const patch = namePatch(resource, data);
    if (!patch) return;
    this.entries.set(`${resource}:${id}`, { revision: ++this.revision, patch });
  }

  apply(resource, data, readRevision) {
    if (!data) return data;
    const id = resource === "devices" ? data.enclosureSerialNumber : data.outlet_id;
    const entry = this.entries.get(`${resource}:${id}`);
    let result = entry && entry.revision > readRevision ? { ...data, ...entry.patch } : data;
    if (resource === "devices" && Array.isArray(data.outlets)) {
      result = { ...result, outlets: data.outlets.map((outlet) => this.apply("outlets", outlet, readRevision)) };
    }
    return result;
  }
}

export function mergeCachedResource(state, resource, id, patch, idField) {
  const result = {};
  const merge = (item) => String(item[idField]) === String(id) ? { ...item, ...patch } : item;
  const mapResource = (key, mapper) => {
    result[key] = (state[key] || []).map(mapper);
    result[`${key}Pages`] = (state[`${key}Pages`] || []).map((page) => ({
      ...page, [key]: (page[key] || []).map(mapper),
    }));
    const cache = state.resourcePageCache?.[key] || {};
    result.resourcePageCache = {
      ...(result.resourcePageCache || state.resourcePageCache),
      [key]: Object.fromEntries(Object.entries(cache).map(([cacheKey, page]) => [cacheKey, {
        ...page, data: (page.data || []).map(mapper),
      }])),
    };
  };
  mapResource(resource, merge);
  if (resource === "outlets") {
    mapResource("devices", (device) => Array.isArray(device.outlets)
      ? { ...device, outlets: device.outlets.map(merge) } : device);
  } else if (resource === "devices" && patch.deviceName !== undefined) {
    mapResource("outlets", (outlet) => String(outlet.enclosureSerialNumber) === String(id)
      ? { ...outlet, deviceName: patch.deviceName } : outlet);
  }
  return result;
}
